// extracted by mini-css-extract-plugin
export default {"list":"AddNewDocument_list__aoyEL","inline":"AddNewDocument_inline__jpQFZ","date":"AddNewDocument_date__gk80b"};